import {Domain, createEndpoint} from '@esgi/contracts';

export class teacherDomain extends Domain {
	public formUpdate = createEndpoint<import('../../../../types/esgi.app/endpoints/abstractions/base-response').BaseResponse, import('../../../../types/esgi.apigateway/api/endpoints/profiles/teacher/form-update/request').Request>('POST', '/v2/profiles/teacher/form-update', this.clientFactory);
}
